import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-view-inventory-dialog',
  templateUrl: './view-inventory-dialog.component.html',
  styleUrls: ['./view-inventory-dialog.component.scss'],
})
export class ViewInventoryDialogComponent implements OnInit {
  product: any

  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.data$.subscribe((data) => {
      this.product = data.product
    })
  }

  ngOnInit(): void {}
  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.VIEW_INVENTORY,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
